import store from "../../../../../app/store";

const saveChatUI = async (botId, ui, templeQues) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/bot/chatappui/${botId}`;
  const token = store.getState().auth.token;

  const sanitizedTemplateQuestions = templeQues
    ?.filter((ele) => ele?.que?.trim() !== "")
    .map((ele) => ele.que);

  if (!token) {
    return {
      data: null,
      error: true,
      msg: "Authentication failed. Please log in again.",
    };
  }

  const option = {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ui,
      TemplateQuestions: sanitizedTemplateQuestions,
    }),
  };

  try {
    const res = await fetch(url, option);

    if (!res.ok) {
      const errMsg =
        res.status === 404
          ? "Bot not found."
          : res.status === 403
          ? "Unauthorized action."
          : "Failed to update chat UI. Please try again.";

      return {
        data: null,
        error: true,
        msg: errMsg,
      };
    }

    const data = await res.json();
    return {
      data,
      error: false,
      msg: "Chat UI updated successfully.",
    };
  } catch (err) {
    console.error("Error updating chat UI:", err);
    return {
      data: null,
      error: true,
      msg: "Server error. Please check your connection and try again.",
    };
  }
};

export default saveChatUI;
